module.exports = __webpack_public_path__ + "img/equip-middle.36347295.jpg";